import { render, staticRenderFns } from "./SamclickDatatable.vue?vue&type=template&id=ccf34198&"
import script from "./SamclickDatatable.vue?vue&type=script&lang=ts&"
export * from "./SamclickDatatable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports